








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Box extends Vue {
  @Prop({ type: String, default: '' }) readonly content_size?: string
}
